import { makeStyles } from '@material-ui/core/styles';

// Components
import Grid from '@material-ui/core/Grid';
import ContentBox from 'components/CncUI/ContentBox';
import Typography from 'components/CncUI/Typography';
import CoronaVirus from './CoronaVirus';
import Welcome from './Welcome';
import Links from './Links';

import useAuthentication from 'hooks/useAuthentication';

const useStyles = makeStyles(({ breakpoints, palette }) => ({
  root: {
    minHeight: '625px',
  },
  header: {
    marginTop: 32,
    marginBottom: 16,
    color: palette.cncUI.primary.gray['+2'],
    [breakpoints.only('xs')]: {
      textAlign: 'center',
    },
  },
  body: {
    padding: 24,
    paddingTop: '3em',
  },
  links: {
    width: '90%',
    margin: '0 auto',
  },
  hr: {
    margin: '1em auto',
    width: '45%',
  },
}));

const Announcements = () => {
  const classes = useStyles();
  const { permissions } = useAuthentication();
  const hasPermission = [
    'tax_documents:read',
    'paystubs:read',
  ].every(permission => permissions.includes(permission));

  return (
    <Grid
      container
      spacing={2}
      direction="column"
      className={classes.root}
      id="Announcements"
    >
      <Grid item xs={12} id="AnnouncementsHeader">
        <Typography variant="h4" className={classes.header}>
          Alerts & Announcements
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <ContentBox id="AnnouncementsContent" className={classes.body}>
          <Grid container spacing={2}>
            <Grid item>
              <Welcome isRegistered={hasPermission} />
            </Grid>
            <hr className={classes.hr} />
            {/* MYCC-1561 Commenting these components out while
                we decide to show other "Improvements" message */}
            {/* <Grid item>
              <Improvements />
            </Grid>
            <hr className={classes.hr} /> */}
            <Grid item>
              <CoronaVirus />
            </Grid>
            <hr className={classes.hr} />
            <Grid item className={classes.links}>
              <Links />
            </Grid>
          </Grid>
        </ContentBox>
      </Grid>
    </Grid>
  );
};

export default Announcements;
